import {match} from 'ts-pattern';

import {CarPassState} from './deriveCarPassState';

const POLLING_INTERVAL_MS = 60 * 1_000;

export const getPollingInterval = (uiState: CarPassState): number =>
  match<CarPassState, number>(uiState)
    .with(
      CarPassState.PENDING,
      CarPassState.WAITING_FOR_DIV,
      CarPassState.ACTION_TAKEN,
      () => POLLING_INTERVAL_MS
    )
    .otherwise(() => 0);
